export default __webpack_public_path__ + "static/media/CT_Userflow.9beca857.png";